module.exports = __webpack_public_path__ + "img/product_logo_mobile.29500f9f.png";